import { getZDL } from '../utils/getZDL';
import { FIXTURES, mergeParamsFixturesIntoZDL } from '../fixtures';

import { Fetch } from '../../shared/types';
import { Zap } from '../types';

type Options = {
  zap: Zap;
};

export const updateZap = (fetch: Fetch, { zap }: Options): Promise<Zap> => {
  return fetch<Zap>(`/api/gulliver/storage/v1/zaps/${zap.id}`, {
    method: 'PATCH',
    body: {
      title: zap.title,
      description: zap.description,
      zdl: mergeParamsFixturesIntoZDL(FIXTURES, getZDL(zap)),
    },
    params: {
      account_id: zap.account_id,
    },
  });
};

export default updateZap;
